import { ComponentType, ReactNode, Suspense } from 'react';
import { isFunction } from '@/shared/types/type-guards/is-function';


export function withSuspense<P> (
    WrappedComponent: ComponentType & any,
    FallbackComponent: ReactNode = null,
    fallbackWithProps: boolean = false
) {
    return function WithSuspense (props: P) {
        if (FallbackComponent === null) {
            console.warn('missed fallback component');
            FallbackComponent = '';
        }

        if (isFunction(FallbackComponent) && props && fallbackWithProps) {
            const Fallback = FallbackComponent as unknown as ComponentType<P>;
            return (
                <Suspense fallback={ <Fallback { ...props }/> }>
                    <WrappedComponent { ...props }/>
                </Suspense>
            );
        }

        return (
            <Suspense fallback={ FallbackComponent }>
                <WrappedComponent { ...props }/>
            </Suspense>
        );
    };
}
